import * as React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { FormGroup, Label } from 'reactstrap';

import { ApiUrls } from '@app/AppConstants';
import { PersonDeleteModel } from '@app/Models/WebApiModels';

import { BaseFormModel } from '@app/Services/BaseFormModel';
import { FormInput } from '@app/Components/FormControls';
import ApiService from '@app/Services/ApiService';
import { NotificationHandler } from '@app/Components/ToastNotification';
import { isRequired } from '@app/Services/Validation';
import { IModalDialogContent, ModalWindow, ModalDialogOptions, ModalButtonType } from '@app/Components/Modal';

type DeleteCallback = () => void;
type PersonDeleteDialogProps = {
    personId: string;
    onDeleteHandler: DeleteCallback;
};

@observer
export class PersonDeleteDialog extends React.Component<PersonDeleteDialogProps, {}> implements IModalDialogContent<void> {
    private _store: PersonDeleteDialogStore;

    constructor(props: PersonDeleteDialogProps) {
        super(props);
        this._store = new PersonDeleteDialogStore(props.personId, props.onDeleteHandler);
    }

    public getModalOptions(window: ModalWindow<void>): ModalDialogOptions<void> {
        return {
            buttons: [{
                type: ModalButtonType.Cancel,
                onClick: () => {
                    window.close();
                }
            }, {
                type: ModalButtonType.Confirm,
                onClick: async () => {
                    if (await this._store.deletePerson()){
                        window.close(ModalButtonType.Confirm);
                    }
                }
            }],
        };
    }

    render() {
        return (
            <>
                <FormGroup>
                    <Label className="label-small">Comment</Label>
                    <FormInput name="comment" formModel={this._store.form} bsSize="sm" />
                </FormGroup>
            </>
        );
    }
}


class FormModel extends BaseFormModel {
    @observable
    @isRequired()
    comment: string = '';
}

class PersonDeleteDialogStore {
    form: FormModel = new FormModel();
    private personId: string;
    private onDeleteHandler: DeleteCallback;
    
    constructor(personId: string, onDeleteHandler: DeleteCallback) {
        this.personId = personId;
        this.onDeleteHandler = onDeleteHandler;
    }

    @action
    async deletePerson() {
        this.form.validate();
        if (!this.form.isFormValid) return false;

        const params: PersonDeleteModel = {
            personId: this.personId,
            comment: this.form.comment
        };

        await ApiService.postData(ApiUrls.PersonDeleteUrl, params);
        NotificationHandler.showInfo('Person was deleted');
        this.onDeleteHandler();
        return true;
    }
}